export const convertHtmlToMarkdown = (html: string) => {
  let orderCount = 0;

  let markdown = html
    // Bold → *text*
    .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
    // Italic → _text_
    .replace(/<em>(.*?)<\/em>/gi, "_$1_")
    // Paragraphs → keep double newlines
    .replace(/<p>(.*?)<\/p>/gi, (m, p1) => `${p1.trim()}\n\n`)
    // Line breaks → single newline
    .replace(/<br\s*\/?>/gi, "\n")
    // List items
    .replace(/<li[^>]*>(.*?)<\/li>/gi, (match, content, index, fullText) => {
      const textBeforeLi = fullText.substring(0, fullText.indexOf(match));
      const lastListTag = textBeforeLi.lastIndexOf("<ol");
      const isOrderedList =
        lastListTag !== -1 &&
        textBeforeLi.substring(lastListTag).indexOf("</ol") === -1;

      if (isOrderedList) {
        orderCount++;
        return `${orderCount}. ${content.trim()}\n`;
      }
      return `• ${content.trim()}\n`;
    })
    // Remove list wrappers
    .replace(/<\/?[uo]l[^>]*>/gi, "\n")
    // Images → alt text
    .replace(/<img[^>]*alt="([^"]*)"[^>]*>/gi, "$1")
    // Strip remaining tags
    .replace(/<\/?[^>]+(>|$)/g, "")
    // Decode &nbsp;
    .replace(/&nbsp;/g, " ")
    // Collapse *3+* newlines into 2 (to preserve blank lines between paragraphs)
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return markdown;
};
